/**
 * B2B employer portal URLs.
 * - Local dev: always localhost:5174/business (B2B Vite app)
 * - Production: DigitalOcean VPS at business.gograbjob.com
 */
const LOCAL_B2B_URL = 'http://localhost:5174/business';
const PROD_B2B_URL = 'https://business.gograbjob.com/business';

function isLocalDevHost(): boolean {
  if (import.meta.env.DEV) return true;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

export function getB2BAppUrl(): string {
  if (isLocalDevHost()) {
    const configured = (import.meta.env.VITE_B2B_URL as string | undefined)?.trim();
    if (configured && /localhost|127\.0\.0\.1/.test(configured)) {
      return configured;
    }
    return LOCAL_B2B_URL;
  }

  const configured = (import.meta.env.VITE_B2B_URL as string | undefined)?.trim();
  if (configured && !/netlify\.app/i.test(configured)) {
    return configured;
  }
  return PROD_B2B_URL;
}

export function openB2BApp(): void {
  window.open(getB2BAppUrl(), '_blank', 'noopener,noreferrer');
}

export function navigateToB2BApp(): void {
  window.location.assign(getB2BAppUrl());
}
